import { createFileRoute } from '@tanstack/react-router';
import { PartnerTeamPage } from '@/pages/partner/PartnerTeamPage';

export const Route = createFileRoute('/partner/organization/users')({
  component: PartnerTeamPage
});
